import React from "react";

const Health = () => {
  return (
    <div>
      <h1>Health Check: 200 OK</h1>
      <h2>Version 3.1 </h2>
    </div>
  );
};

export default Health;
